import { StyledHelloView } from ".";
import { avatar, avatarAvif, LinkedInIcon } from "../../assets";
import { FC, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useReward } from "react-rewards";

const HelloView: FC = () => {
  const { reward } = useReward("confetti", "confetti", {
    angle: 90,
    elementSize: 10,
    elementCount: 200,
    startVelocity: 55,
  });

  useEffect(() => {
    reward();
  }, []);

  return (
    <StyledHelloView>
      <div id="confetti" />
      <Helmet>
        <title>Hello | Jamel Hammoud</title>
      </Helmet>
      <div
        dangerouslySetInnerHTML={{
          __html:
            "<!-- Hey! I wrote this with my own brain and hands. Kinda cool eh? (yeah yeah, I use Claude for everything else.) -->",
        }}
      />
      <main>
        <div className="profile-photo-container">
          <div className="profile-photo">
            <picture>
              <source srcSet={avatarAvif} type="image/avif" />
              <img src={avatar} alt="Jamel Hammoud" />
            </picture>
          </div>
          <div className="hand">
            <span>👋</span>
          </div>
        </div>
        <h1>Hey, I'm Jamel</h1>
        <p>I thought it would be cool to have my own ChatGPT ad. That's all.</p>

        <a
          href="https://www.linkedin.com/in/jamelhammoud/"
          className="connect-btn"
        >
          <LinkedInIcon />
          Let's connect
        </a>
      </main>
    </StyledHelloView>
  );
};

export default HelloView;
